import * as z from "zod";
import { upsertSkillFiles } from "../skillFiles";
import { mutator } from "./mutator";

export const upsertSkillFileSchema = z.object({
  skillId: z.string(),
  path: z.string(),
  content: z.string(),
  encoding: z.enum(["utf8", "base64"]),
});

export const upsertSkillFile = mutator({
  redactKeys: ["content"],
  schema: upsertSkillFileSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  fn: async ({ tx, ctx, args: { skill, path, content, encoding } }) => {
    await upsertSkillFiles(tx, skill.id, ctx.tenantId, {
      [path]: { content, encoding },
    });
  },
});
